import axiosClient from './axiosClient';

export const getQuestions = () => {
  return axiosClient.get('/admin/questions');
};

export const addQuestion = (data) => {
  return axiosClient.post('/admin/questions', data);
};

export const updateQuestion = (id, data) => {
  return axiosClient.put(`/admin/questions/${id}`, data);
};

export const deleteQuestion = (id) => {
  return axiosClient.delete(`/admin/questions/${id}`);
};

export const bulkDeleteQuestions = (questionIds) => {
  return axiosClient.post('/admin/questions/bulk-delete', { questionIds });
};

export const uploadBulkQuestions = (formData) => {
  return axiosClient.post('/admin/questions/bulk', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
